import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, onMounted } from "vue";
import { Messages } from "@/message";
import { Paths } from "@/plugins/api/paths";
import { AttendanceAlertRequest } from "@/models/alert/AlertRequest";
import { PetitionShiftSearch } from "@/models/petition/PetitionResponse";
import { $post } from "@/plugins/api/api";
import VacationApplication from "../petition/form/VacationApplication.vue";
import { DateTime } from "luxon";
import { fromMillisSafe } from "@/utils/luxon";

type Props = {
  affiliationId: number;
  employeeId: number;
};

type Emits = {
  (e: "alertdialog", val: boolean): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'AbsentAlert',
  props: {
    affiliationId: null,
    employeeId: null
  },
  emits: ["alertdialog"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "alertdialog", val: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  affiliationId: number;
  employeeId: number;
};





const isDialog = ref(false);
const shift = ref<PetitionShiftSearch>();

const date = ref(DateTime.local());

const form = ref<InstanceType<typeof VacationApplication>>();

const getPetitionShiftSearch = async () => {
  const request = new AttendanceAlertRequest({
    employeeId: props.employeeId,
    affiliationId: props.affiliationId
  });
  shift.value = await $post<PetitionShiftSearch>(Paths.alert.absent, request);
};

watch(shift, (newValue?: PetitionShiftSearch) => {
  if (newValue?.attendanceDate)
    date.value = fromMillisSafe(newValue.attendanceDate);
});

watch(isDialog, (newValue: boolean) => {
  console.log("isDialog", newValue);
  emits("alertdialog", newValue);
});

watch(
  () => props.employeeId,
  async () => await getPetitionShiftSearch()
);

watch(
  () => props.affiliationId,
  async () => await getPetitionShiftSearch()
);

const onSubmit = async () => {
  const result = await form.value?.onSubmit();
  if (result) {
    isDialog.value = false;
    await getPetitionShiftSearch();
  }
};

onMounted(async () => await getPetitionShiftSearch());

return { __sfc: true,emits, props, isDialog, shift, date, form, getPetitionShiftSearch, onSubmit, Messages, VacationApplication }
}

})